<template>
  <sub-page :title="title">
    <div class="map-page">
      <div class="map-card" v-for="(item, idx) in items" :key="idx">
        <div class="card-header">
          <div class="card-title">{{ item.title }}</div>
          <div class="card-desc">{{ item.desc }}</div>
        </div>
        <div class="card-btn" @click="handleClick(item)">点击查看</div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'MapService',
  components: { SubPage },
  data() {
    return {
      title: '地图服务',
      items: [
        { title: '就近办', desc: '人社部门或其所属社保经办机构，与商业银行合作，借助银行营业网点和自助服务终端，向群众提供社会保险、就业创业、劳动关系等人社公共服务' },
        { title: '社会保障卡服务网点', desc: '人社部门联合社保卡合作银行共建社保卡服务网点，为群众提供申领、补换、挂失等社保卡服务' },
        { title: '档案管理服务机构', desc: '为流动人员提供人事档案接收、转递、查借阅、政审服务等公共服务' },
        { title: '职业技能培训机构', desc: '经行政许可设立的职业院校、技工院校、职业技能培训机构，为劳动者提供职业技能培训服务' },
        { title: '职业技能等级评价机构', desc: '经备案设立的职业技能等级评价机构，为劳动者提供职业技能等级认定服务' },
        { title: '十五分钟公共就业服务', desc: '以公共就业和人才服务机构为枢纽，联动人力资源市场、零工市场、就业驿站等，为劳动者提供就业服务' },
        { title: '技工院校', desc: '经行政许可设立的技工院校，为各类劳动者提供技工教育、职业技能培训服务' },
        { title: '创业园区', desc: '为创业者提供创业场地、创业指导、创业培训、融资对接等服务的创业孵化基地' }
      ]
    }
  },
  methods: {
    handleClick(item) {
      // 点击查看逻辑
    }
  }
}
</script>

<style scoped>
.map-page {
  background: #F3F8FB;
  min-height: 100%;
  padding: calc(24 * var(--w)) calc(32 * var(--w));
}
.map-card {
  background: #fff;
  border-radius: calc(8 * var(--w));
  padding: calc(32 * var(--w));
  margin-bottom: calc(24 * var(--w));
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.card-header {
  flex: 1;
  margin-right: calc(24 * var(--w));
}
.card-title {
  font-size: calc(40 * var(--w));
  font-weight: 500;
  color: #323233;
  margin-bottom: calc(16 * var(--w));
}
.card-desc {
  font-size: calc(26 * var(--w));
  color: #969799;
  line-height: 1.6;
}
.card-btn {
  flex-shrink: 0;
  padding: calc(12 * var(--w)) calc(32 * var(--w));
  background: #2E8CF6;
  color: #fff;
  font-size: calc(26 * var(--w));
  border-radius: calc(40 * var(--w));
  cursor: pointer;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/MapService.vue